(() => {
  if (window.__cloudSearchPlaceholdersInit) return;
  window.__cloudSearchPlaceholdersInit = true;

  let debounceTimer = null;
  let isMutating = false;

  function hasUsableImage(dt) {
    const img = dt.querySelector('.list-image img');
    if (!img) return false;
    const src = (img.getAttribute('src') || '').trim();
    if (!src) return false;
    if (!img.complete) return true;
    return img.naturalWidth > 0;
  }

  function insertReservedSpan(row) {
    if (row.querySelector('.list-image--reserved')) return;
    const el = document.createElement('span');
    el.className = 'list-image list-image--reserved';
    el.setAttribute('aria-hidden', 'true');
    isMutating = true;
    row.insertBefore(el, row.firstChild);
    isMutating = false;
  }

  function getListImageEl(dt) {
    return dt.querySelector('.list-image');
  }

  function syncRow(dt) {
    const listImage = getListImageEl(dt);
    const img = listImage?.querySelector('img');

    if (hasUsableImage(dt)) {
      if (img) img.hidden = false;
      listImage?.classList.remove('list-image--reserved');
      dt.querySelector('span.list-image--reserved')?.remove();
      return;
    }

    if (listImage) {
      if (img) img.hidden = true;
      listImage.classList.add('list-image--reserved');
      return;
    }

    insertReservedSpan(dt);
  }

  function syncRoot(root) {
    root.querySelectorAll('dt.cs-item, a.cs-item').forEach(syncRow);
  }

  function scheduleSync(root) {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      debounceTimer = null;
      syncRoot(root);
    }, 80);
  }

  function watchImages(root) {
    root.querySelectorAll('.list-image img').forEach((img) => {
      if (img.dataset.placeholderBound) return;
      img.dataset.placeholderBound = 'true';
      const row = img.closest('dt.cs-item, a.cs-item');
      if (!row) return;
      const onChange = () => scheduleSync(root);
      img.addEventListener('load', onChange, { once: true });
      img.addEventListener('error', onChange, { once: true });
    });
  }

  function bind(root) {
    if (!root || root.dataset.placeholdersBound) return;
    root.dataset.placeholdersBound = 'true';

    syncRoot(root);
    watchImages(root);

    new MutationObserver(() => {
      if (isMutating) return;
      watchImages(root);
      scheduleSync(root);
    }).observe(root, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('#cloud-search-results, .cloud-search-results').forEach(bind);

    new MutationObserver(() => {
      document.querySelectorAll('#cloud-search-results, .cloud-search-results').forEach((el) => {
        if (!el.dataset.placeholdersBound) bind(el);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
